<script setup lang="ts">
const { sourcesUrl } = useRuntimeConfig().public;
const { $i18n } = useNuxtApp();
const { data: faqJSON } = await useFetch<FAQData>(
  `${sourcesUrl}/marketplace/locales/${$i18n.locale.value}/influencer-program-faq.json`,
  {
    default: () => ({}),
  }
);
const { t } = useI18n();
useSeoMeta({
  title: `${t(`main.appMenu.referrals`)}`,
});
</script>

<template>
  <div>
    <ReferralsApplyForm class="mt-1" />
    <ReferralsFAQ v-if="faqJSON" class="mt-6" :faq-data="faqJSON" />
  </div>
</template>
